import { StatementType } from './statement-types';

export const EnglishStatements: Record<StatementType, string[]> = {
  annoyed: [
    "It's not like I didn't tell you about it yesterday?",
    "Don't think I haven't been paying attention!",
    "I can't think in this racket!",
    'Passive aggressive much?',
    "You know that doesn't go there!",
    "It's been 7 hours and 15 days since you borrowed my lawnmower!",
    'Do you have to chew so loudly?',
    'Just take it already!',
    "If you've got nothing good to say, then say nothing at all!",
    "Let's just go already.",
  ],
  frustrated: [
    'Have it your way then!',
    "I'm never going to get this!",
    "The website isn't loading!",
    "This can won't open!",
    "You can't open it like that!",
    'You always have to have the last word!',
  ],
  angry: [
    "WHAT THE HELL DO YOU THINK YOU'RE DOING!?",
    'Bastard son of a brooding viper!',
    "I'm going to kill you!",
    "No, you're wrong!",
    'You were supposed to protect us!',
  ],
  random: [
    'The geese are coming! The geese are coming!',
    'Sweet potatoes are neither sweet nor potatoes.',
    'Alrighty then! Yalla!',
    'Will miracles never cease!',
    '"Wow, that\'s a lot of blueberries!"',
    'Hot diggitty dog!',
    'Are you sure you want to do that?',
    'Lord have mercy!',
    'The sky is so blue today.',
    "I ain't afraid of no ghost!",
    "I guess you don't know how to cook?",
    "Let's all calm down and take a deep breath.",
    'Love is the answer.',
  ],
  child: [
    'Haha!',
    'Not fast enough!',
    'Oh boy!',
    'OLD!',
    'hahahaha',
    'Weeeee',
    'Want to give up yet?',
    'Watch this!',
    'Getting tired?',
    'Excuse me!',
    'Watch out!',
  ],
  'child-no': ['No!'],
  'stay-near-me': ["Stay near me, don't wander."],
};
